<template>
<div class="hostEdit form dialog-form">
    <el-dialog title="编辑主持人信息" :visible.sync="dialogVisible">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
            <el-form-item label="" prop="fileInfo" class="upload-image">
                <!--<upload class="sponsor-logo" :imgRule="imgRule" ref="upload" @setImage="setImage"></upload>-->
                <div class="upload sponsor-logo" @click="openLocalGallery">
                    <div class="avatar-uploader">
                        <div tabindex="0" class="el-upload el-upload--text">
                            <i class="el-icon-plus avatar-uploader-icon icon_upload" v-if="!item.fileInfo.furl"></i>
                            <img :src="item.fileInfo.furl +'?'+timestamp" alt="" class="avatar" v-if="item.fileInfo.furl">
                        </div>
                    </div>
                </div>
                <!-- <div class="el-upload__tip">{{item.fileInfo.furl}}建议像素：120（宽）*120（高），JPG、PNG格式，大小不超过5M。</div> -->
                <div class="el-upload__tip">建议像素：120（宽）*120（高），JPG、PNG格式，大小不超过5M。</div>
            </el-form-item>
            <el-form-item label="" prop="name">
                <el-input v-model.trim="item.name" clearable maxlength="30" show-word-limit></el-input>
            </el-form-item>
            <el-form-item class="form-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="setImage" :uploadType="uploadType"></localCropper>
</div>
</template>

<script>
import LocalCropper from 'base/cropper/localCropper'
import {vliveMsg} from 'api/message'
export default {
    name: 'hostEdit',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            if (!value.furl) {
                callback(new Error('请选择图片'))
            } else {
                callback()
            }
        }
        return {
            timestamp: new Date().getTime(), // 时间戳
            cropperOption: {
                fixedNumber: [100, 100], // 截图框的宽高比例
                enlarge: 1, // 图片根据截图框输出比例倍数
                autoCropWidth: 100, // 默认生成截图框宽度
                autoCropHeight: 100 // 默认生成截图框高度
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            dialogVisible: false,
            item: {
                fileInfo: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                },
                name: ''
            },
            rules: {
                fileInfo: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        setImage(file) {
            this.timestamp = new Date().getTime()
            this.item.fileInfo = file
        },
        openDialog(row) {
            this.dialogVisible = true
            this.item = Object.assign({}, row)
        },
        cancel() {
            this.$confirm(vliveMsg.cancelHostInfo.msg, vliveMsg.cancelHostInfo.title, {
                confirmButtonText: vliveMsg.cancelHostInfo.confirmText,
                cancelButtonText: vliveMsg.cancelHostInfo.cancelText
            }).then(() => {
                this._cancel()
            })
        },
        _cancel() {
            this.$refs.ruleForm.resetFields()
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm(vliveMsg.submitHostInfo.msg, vliveMsg.submitHostInfo.title, {
                        confirmButtonText: vliveMsg.submitHostInfo.confirmText,
                        cancelButtonText: vliveMsg.submitHostInfo.cancelText
                    }).then(() => {
                        this.$emit('setHostInfo', this.item.name, this.item.fileInfo)
                        this._cancel()
                    })
                }
            })
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LocalCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.hostEdit {
    .upload-image{
        .el-form-item__content{
            @include flexBox(flex-start)
        }
        .sponsor-logo{
            margin-right: 20px;
        }
        .avatar-uploader{
            box-sizing: border-box;
            height: 100px;
            width: 100px;
        }
        .el-upload__tip{
            align-self: center;
        }
    }
}
</style>
